import React from 'react';
import '../App.scss';
import '../Login.scss';
import './ResetPassword.scss';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import { ReactComponent as Logo } from '../image/logosvg.svg'
import axios from 'axios';
import qs from 'query-string'

const useStyles = makeStyles(theme => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: 'url(https://source.unsplash.com/random)',
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  modal: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    padding: '70px',
    width: '300px',
    textAlign: 'center'
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  paper: {
      position: 'absolute',
      width: 450,
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
  },
  buttonForgot: {
    fontSize: '16px',
    "&:hover, &:focus": {
      cursor: 'pointer'
    }
  },
  closeButton: { cursor:'pointer', float:'right', marginTop: '5px', width: '20px' },
  inputLabel: {
    color: "#00000",
    fontSize: '20px',
    "&.focused": {
      color: "#18EA95",
      //border: "2px solid #18EA95",
      fontSize: "20px"
    },
    '&.MuiInput-underline:after': {
      borderBottomColor: '#18EA95',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: "#18EA95",
      },
      '&:hover fieldset': {
        borderColor: "#18EA95",
      },
      '&.Mui-focused fieldset': {
        borderColor: "#18EA95",
      }
    }
  },
  inputLabelProps: {
    color: '#18EA95',
    fontSize: '20px',
    "&.focused": {
      color: "#18EA95",
      //border: "2px solid #18EA95",
      fontSize: "20px"
    },
  },
}));

export const getQueryStringValue = ( 
  key, 
  queryString = window.location.search
) => { 
  const values = qs.parse(queryString); 
  return values[key];
};

const encryptBase64Password = (s) => {
  var b = new Buffer(s);
  return b.toString('base64');
}

function ResetPassword(codee, usernamee) {
  const code = getQueryStringValue('code');
  const username = getQueryStringValue('username');
  const classes = useStyles();
  const [errorMessage, setErrorMessage] = React.useState('')
  const [input, setInput] = React.useState({})
  const [infoMessage, setInfoMessage] = React.useState('')

  const onResetPassword = () => {
    if(!username || !code || !input.newpassword || !input.confirmpassword || input.newpassword.trim().length === 0 || input.confirmpassword.trim().length === 0) {
      setErrorMessage('Something is missing.')
    } else {
      const new_password = encryptBase64Password(input.newpassword);
      const confirm_password = encryptBase64Password(input.confirmpassword);
      axios.post('/api/resetpassword', { username, code, newpassword: new_password, confirmpassword: confirm_password }).then((result) => {
        console.log(result.data);
        if(!result.data.context || !result.data.success) {
          setErrorMessage('Invalid Credentials.')
        }
        if(result.data.success) {
          setErrorMessage('')
          setInfoMessage('Your Password has been changed.')
          setInput({})
        }
      })
    }
  }

  const handleInputChange = (e) => setInput({
    ...input,
    [e.currentTarget.name]: e.currentTarget.value
  })
  return (
    <div className="App">
      <header>
        <div className="logo"><Logo/></div>
      </header>
      <div className="containerResetPassword">
        <div className="containerCenter">
          <h2>Choose New Password</h2>
          <form className={classes.form} noValidate>
          <TextField
              InputProps={{
                classes: {
                  root: classes.inputLabel,
                }
              }}
              InputLabelProps={{
                classes: {
                  root: classes.inputLabelProps,
                  focused: "focused"
                }
              }}
              margin="normal"
              fullWidth
              id="user"
              name="user"
              value={getQueryStringValue('username')}
              label="User"
              type="text"
              readonly
            />
            <TextField
              InputProps={{
                classes: {
                  root: classes.inputLabel,
                }
              }}
              InputLabelProps={{
                classes: {
                  root: classes.inputLabelProps,
                  focused: "focused"
                }
              }}
              margin="normal"
              required
              fullWidth
              id="newpassword"
              label="New Password"
              name="newpassword"
              type="password"
              autoFocus
              onChange={handleInputChange}
            />
            <TextField
                InputProps={{
                  classes: {
                    root: classes.inputLabel,
                  }
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.inputLabelProps,
                    focused: "focused"
                  }
                }}
              margin="normal"
              required
              fullWidth
              name="confirmpassword"
              label="Confirm Password"
              type="password"
              onChange={handleInputChange}
              id="confirmpassword"
            />
              
            <div className="bodyButton fullWidth topbottomMargin10" onClick={() => onResetPassword()}><div className="hAlign">Reset Password</div></div>
            { errorMessage !== '' && <div className="error">{errorMessage}</div> }
            { infoMessage !== '' && <div className="info">{infoMessage}</div> }
          </form>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
